<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-row v-if="data.FSerial_StudentMaharat == ''" align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>مهارت:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="10">
          <v-autocomplete
            v-model="data.Fserial_KMaharat"
            :items="selectableMaharats"
            item-text="Text"
            item-value="Value"
            no-data-text="داده ای برای نمایش وجود ندارد."
            :filter="customFilter"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="10">
          <v-text-field
            v-model="data.Comment"
            maxlength="2000"
            :oninput="onInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="2">
          <b>مدرک:</b>
        </v-col>

        <v-col class="d-flex" cols="10" style="direction: ltr">
          <v-switch
            color="primary"
            v-model="data.Madrak"
            label="دارم/ ندارم"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="5" sm="2">
          <b>سال اخذ:</b>
        </v-col>

        <v-col class="d-flex" cols="7" sm="2">
          <v-text-field
            v-model="data.Madrak_Sal"
            maxlength="4"
            type="number"
            :oninput="onInput"
            :disabled="!data.Madrak"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="5" sm="3">
          <b>صادركننده مدرك:</b>
        </v-col>
        <v-col class="d-flex" cols="7" sm="5">
          <v-text-field
            v-model="data.Madrak_Saderkonandeh"
            maxlength="50"
            :oninput="onInput"
            :disabled="!data.Madrak"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card-actions style="direction: ltr">
        <v-btn
          class="register"
          color="primary white--text"
          rounded
          @click="$emit('saveMaharat', null)"
        >
          بستن
        </v-btn>
        <v-btn
          class="register"
          color="red white--text"
          rounded
          @click="$emit('saveMaharat', data)"
        >
          ثبت
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { toArabicCharacter } from "@/utils/constants";
export default {
  data() {
    return { activeInfo: [], maharat: "" };
  },
  props: ["show", "data", "selectableMaharats"],

  computed: {
    filterInfo() {
      let actives = this.activeInfo.filter((single) => {
        return single.Selected || single.FSerial_StudentMaharat != "";
      });
      if (this.filter == "0") {
        return actives;
      } else {
        return actives.filter((single) => {
          return single.Serial_Category == this.filter;
        });
      }
    },

    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const text = toArabicCharacter(item.Text);

      const searchText = toArabicCharacter(queryText);

      return text.indexOf(searchText) > -1;
    },
    addMaharat() {
      for (let i = 0; i < this.activeInfo.length; i++) {
        if (this.activeInfo[i].Fserial_KMaharat == this.maharat) {
          this.activeInfo[i].Selected = true;
          break;
        }
      }
    },
  },
  watch: {
    info(newvalue) {
      this.activeInfo = newvalue;
    },
  },
};
</script>
<style scoped>

.v-card {
  margin: 0;
  padding: 30px 10px 10px;
  border-radius: 4px !important;
}
.register {
  width: 30% !important;
  max-width: 150px !important;
}
</style>
<style>
.v-input--switch .v-label {
  min-width: 70px;
}
</style>
